<template>
  <div class="tileButtons">
    <div class="tileButtons_item" v-for="item in items" :key="item">
      <router-link :to="item.link">
        <div class="tileButton" :data-icon="item.icon">
          <p :data-badge="item.badgeNum">
            <img
              :src="require(`@/assets/images/icon/${item.icon}.svg`)"
              alt=""
            />
          </p>
          <p class="tileButton_label">{{ item.label }}</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script lnag="ts">
export default {
  name: 'TileButtons',
  props: {
    items: Array
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.tileButtons {
  display: flex;
  flex-wrap: wrap;
  margin: 9px -9px;
  @include mixins.media() {
    margin: 0 -20px;
  }
}

.tileButtons_item {
  flex-basis: calc(50% - 18px);
  margin: 9px;
  @include mixins.media() {
    flex-basis: 148px;
    margin: 0 20px;
  }
}

.tileButton {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 120px;
  border: 1px solid var.$color-border-gray;
  border-radius: 10px;
  box-shadow: 0 6px 9px rgba(0, 0, 0, 0.08);
  line-height: 1;
  font-size: 1.4rem;
  color: var.$color-main-text;
  letter-spacing: normal;
}

.tileButton p[data-badge] {
  position: relative;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    content: attr(data-badge);
    background-color: var.$color-red;
    width: 19px;
    height: 19px;
    border-radius: 100%;
    font-size: 1rem;
    font-weight: 500;
    color: #fff;
    transform: translate(12px, -12px);
  }
}

.tileButton p[data-badge='0']::after {
  display: none;
}

.tileButton_label {
  margin-top: 15px;
}

.tileButton img {
  width: auto;
}

.tileButton[data-icon='heart'] img {
  height: 35px;
}

.tileButton[data-icon='envelope'] img {
  height: 32px;
}

.tileButton[data-icon='document'] img {
  height: 40px;
}

.tileButton[data-icon='hospital-02'] img {
  height: 36px;
}

.tileButton[data-icon='calendar'] img {
  height: 40px;
}

.tileButton[data-icon='ping-02'] img {
  height: 44px;
}

.tileButtons.-sideNav {
  margin-top: -8px;
  margin-bottom: -8px;

  .tileButtons_item {
    flex-basis: 100%;
    margin: 8px;
  }
  .tileButton {
    flex-direction: row;
    justify-content: flex-start;
    height: 75px;
    position: relative;

    > p[data-badge] {
      width: 70px;
      flex-grow: 0;
      text-align: center;

      &:after {
        right: 20px;
      }

      @include mixins.media(lg) {
        width: 80px;

        &:after {
          right: 25px;
        }
      }
    }

    &_label {
      margin-top: 0;
      line-height: 1.4;
      padding-right: 10px;
      font-size: 1.3rem;

      @include mixins.media(lg) {
        padding-right: 25px;
        font-size: 1.4rem;
      }
    }
  }
  .tileButton[data-icon='heart'] img {
    height: 26px;
  }
  .tileButton[data-icon='user-clock'] img {
    height: 30px;
  }
  .tileButton[data-icon='document'] img {
    height: 30px;
  }
  .tileButton[data-icon='hospital-02'] img {
    height: 26px;
  }
}
</style>
